<div fxFlex="row" fxFlex>
    <div fxFlex="240px" class="sidenavigationTop hidexs" *ngIf="showFooter">
        <div class="iwg-service-name">Contractor Invoices</div>
        <div class="sidenavigationInner">
            <app-buttonbar></app-buttonbar>
        </div>
    </div>
    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div *ngIf="!showFooter">
            <a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" *ngIf="ShowCreateInvoice"
                                (click)="showVendorInvoiceDialog($event, null); $event.preventDefault();" layout="row">
                New Invoice
                <span flex></span>
                <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
        </div>
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span *ngIf="showFooter">Invoices » </span><span>Contractor Invoices</span> »
                <span class="iwg-page-header-small-title">{{this.globalScopes[this.state.global_scope - 1].name}}</span>
            </div>
            <div layout="column" flex>
                <div class="iwg-summary" layout="row" layout-xs="column" *ngIf="summary">
                    <div flex *ngFor="let item of summary" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName
                            && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
                        <div class="iwg-value">{{item.Value}}</div>
                        <div class="iwg-label">{{item.Name}}</div>
                    </div>
                </div>
                <div>
                    <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
                                   (selectedTabChange)="onTabChanged($event);">
                        <mat-tab *ngFor="let scope of globalScopes" label="{{scope.name}}">
                            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
                        </mat-tab>
                    </mat-tab-group>

                    <ng-template #tabContent>
                        <div class="vistafilter-wrapper">

                            <div class="vistafilter-section1">

                                <div class="vistafilter-innersection1" style="font-size: 15px;">Contractor Invoices From:</div>

                                <div class="vistafilter-innersection2">
                                    <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                                    <mat-form-field appearance="none" color="accent">
                                        <input matInput [matDatepicker]="start" [(ngModel)]="state.start"
                                               [max]="state.end" (dateChange)="handleDateChange($event)">
                                        <mat-datepicker-toggle matSuffix [for]="start">
                                            <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #start></mat-datepicker>
                                    </mat-form-field>

                                </div>


                                <div class="vistafilter-innersection3">
                                    <div class="vistafilter-subsection3">To:</div>

                                    <div class="vistafilter-subsection4">
                                        <mat-datepicker-toggle matSuffix [for]="end">
                                        </mat-datepicker-toggle>
                                        <mat-form-field appearance="none" color="accent">
                                            <input matInput [matDatepicker]="end" [(ngModel)]="state.end"
                                                   [min]="state.start" (dateChange)="handleDateChange($event)">
                                            <mat-datepicker-toggle matSuffix [for]="end">
                                                <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #end></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="vistafilter-section2">
                                <div class="vistafilter-subsection1 vistafilter-subsection1-search">

                                    <mat-form-field style="width: 100%;">
                                        <mat-label>Search</mat-label>
                                        <input matInput [(ngModel)]="state.q"
                                               (input)="onSearchChange($event.target.value)">
                                    </mat-form-field>

                                </div>
                                <div class="vistafilter-subsection2">

                                    <button mat-icon-button aria-hidden="false" aria-label="Download"
                                            class="inputassignicon"
                                            (click)="exportTable()">
                                        <mat-icon>file_download</mat-icon>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="wrapper1" #wrapper1>
                    <div class="div1" #div1></div>
                </div>
                <div class="wrapper2" #wrapper2>

                    <div class="div2" #div2>
                        <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
                        <mat-table #listTable matTableExporter matSort [dataSource]="dataSource" [matSortActive]="state.order_by"
                                   [matSortDirection]="state.order" (matSortChange)="sortData($event)" style="min-width: 100%;">

                            <ng-container matColumnDef="IDCol">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear
                                                 class="tabledhead hidexs"> ID</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    {{vendorInvoice.DisplayID}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="InvoiceNumber">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="InvoiceID" disableClear
                                                 class="tabledhead">Invoice Number</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="">
                                    <a [routerLink]="['/vendor-invoices', vendorInvoice.ID]" [queryParams]="{
                                                  service: state.service,
                                                  page: state.page,
                                                  limit: state.limit,
                                                  order_by: state.order_by,
                                                  order: state.order,
                                                  start: state.start,
                                                  end: state.end,
                                                  q: state.q,
                                                  country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                                  global_scope: state.global_scope
                                                    }">{{vendorInvoice.InvoiceNumber}}</a>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Title">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="TitleLabel" disableClear
                                                 class="tabledhead hidexs">Invoice Title</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    {{vendorInvoice.Title | blank}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Invoice">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="InvoiceTitle" disableClear fxHide.gt-sm
                                                 class="tabledhead hidexs">Invoice</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" fxHide.gt-sm class="hidexs">
                                    <a [routerLink]="['/vendor-invoices', vendorInvoice.ID]" [queryParams]="{

                                        service: state.service,
                                        page: state.page,
                                        limit: state.limit,
                                        order_by: state.order_by,
                                        order: state.order,
                                        start: state.start,
                                        end: state.end,
                                        q: state.q,
                                        country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                        global_scope: state.global_scope
                                          }">{{vendorInvoice.Title}}</a>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="InvoiceDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="InvoiceDateLabel" disableClear
                                                 class="tabledhead">Invoice Date</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="">
                                    {{vendorInvoice.InvoiceDate}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Candidate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="CandidateLabel" disableClear
                                                 class="tabledhead hidexs"> Contractor</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    {{
vendorInvoice.Candidate |
                                    blank
                                    }}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Client">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="ClientLabel" disableClear
                                                 class="tabledhead hidexs">Client</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    {{vendorInvoice.Client | blank}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Manager">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="ManagerName" disableClear
                                                 class="tabledhead hidexs">Manager</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    {{vendorInvoice.Manager | blank}}
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="TotalInEngagement">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Amount</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice">
                                    {{vendorInvoice.EngamentCurrencySymbol}}{{
vendorInvoice.TotalInEngagmentCurrency |
                                    number : '1.2-2'
                                    }} ({{vendorInvoice.EngamentCurrencyCode}})
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Status">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="StatusLabel" disableClear class="hidexs"> Status</mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs"> {{vendorInvoice.Status}} </mat-cell>
                            </ng-container>

                            <!-- Operations Menu -->
                            <ng-container matColumnDef="OprMenu">
                                <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
                                <mat-cell *matCellDef="let vendorInvoice" class="hidexs">
                                    <button mat-icon-button [matMenuTriggerFor]="menu"
                                            aria-label="Example icon-button with a menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu" backdropClass="submenualignment" class="submenu">
                                        <button mat-menu-item [routerLink]="['/vendor-invoices', vendorInvoice.ID]"
                                                [queryParams]="{
                                            service: state.service,
                                            page: state.page,
                                            limit: state.limit,
                                            order_by: state.order_by,
                                            order: state.order,
                                            start: state.start,
                                            end: state.end,
                                            q: state.q,
                                            country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                            global_scope: state.global_scope
                                          }">
                                            Show Details
                                        </button>
                                        <button mat-menu-item
                                                *ngIf="(vendorInvoice.StatusID == 5 || vendorInvoice.StatusID == 9) && allowEdit"
                                                (click)="editInvoice($event,vendorInvoice.ID)">
                                            Edit
                                        </button>

                                        <button mat-menu-item
                                                *ngIf="vendorInvoice.StatusID != 5 && vendorInvoice.StatusID != 9 && allowEdit"
                                                (click)="delete(vendorInvoice.ID)">
                                            Delete
                                        </button>
                                    </mat-menu>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>

                    </div>
                </div>

                <mat-paginator [length]="totalRecords" [pageSize]="state.limit" class="myvista-paginator"
                               (page)="pageEvent = $event; naviatePageTo($event)" [pageSizeOptions]="[25, 100, 500, 1000, 10000]"
                               showFirstLastButtons>
                </mat-paginator>

            </div>


        </div>
        <div *ngIf="showFooter" class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>